// zajistí, aby jquery resize trigger volal i event //
if (window.$) {
    
    let fn;
    
    if(typeof(Event) === 'function') {
        fn=function(e) {
            if (e.isTrigger) {
                if (typeof e.currentTarget.dispatchEvent === "function") {e.currentTarget.dispatchEvent(new Event(e.type));}
            }
        }
    } else {
        fn=function(e) {
            if (e.isTrigger) {
                if (typeof e.currentTarget.dispatchEvent === "function") {
                    var event = document.createEvent('Event');
                    event.initEvent(e.type, true, true);
                    e.currentTarget.dispatchEvent(event);
                }
            }
        }
    }

    $(window).on('resize', fn);

};

document.head.insertAdjacentHTML("beforeend", "<style>.main.-vut-resize-locked{overflow:hidden !important;}</style>");

window.VUTResizeHandler={
    observerTimeout:0,
    resizeTimeout:0,
    _handlers:[],
    dispatch:function() {
        if (typeof window.CustomEvent === "function") {
            try {
                var ee=new CustomEvent("resize", {bubbles:true});
                window.dispatchEvent(ee);
            if (window.gl_debug) {console.info("resize dispatch VUTResizeHandler");}
                return true;
            } catch(e) {}
        }
        return false;
    },
    add:function(f){
        if ((typeof f == "function")&&(!(~VUTResizeHandler._handlers.indexOf(f)))) {VUTResizeHandler._handlers.push(f); VUTResizeHandler.handle(); return true;}
        return false;
    },
    remove:function(f){
        var e;
        if ((typeof f == "function")&&(~(e=VUTResizeHandler._handlers.indexOf(f)))) {VUTResizeHandler._handlers.splice(e,1); return true;}
        return false;
    },
    handle:function(event){
        if (!VUTResizeHandler._handlers.length) return;
        if (event) {clearTimeout(VUTResizeHandler.resizeTimeout); VUTResizeHandler.resizeTimeout=setTimeout(function(){VUTResizeHandler.handle(false);},250); return;}
        var t0=performance.now();
        if (document.querySelector(".main")) {
            document.querySelector(".main").classList.add("-vut-resize-locked");
            var m=document.querySelector(".main");
            var w=m.offsetWidth;
            var s=getComputedStyle(m);
            w-=parseInt(parseFloat(s["padding-left"])+parseFloat(s["padding-right"]));
        }
        VUTResizeHandler._handlers.forEach(function(f){
            try {f(null, w);}
            catch(e) {console.error(e);}
        });
        if (window.gl_debug) {console.info("resize obsloužené VUTResizeHandler; "+(VUTResizeHandler._handlers.length)+" posuchačů")}
        if (document.querySelector(".main")) {document.querySelector(".main").classList.remove("-vut-resize-locked");}
        if (typeof window.CustomEvent === "function") {
            try {
                var ee=new CustomEvent("scroll", {bubbles:true});
                window.dispatchEvent(ee);
            } catch(e) {}
        }        
    },
}

window.addEventListener("resize", VUTResizeHandler.handle);

